<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Switch({
              label: 'Automatyczna rotacja',
              modelPath: [this, 'form', 'is_autorotate']
            }),
            new fields.Input({
              label: 'Czas pomiędzy zmianą slajdu',
              modelPath: [this, 'form', 'interval'],
              type: 'number',
              condition: !!this.form.is_autorotate
            }),
            new fields.Header({
              text: 'Slajdy'
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((item, i) => ({
                headerLabel: get(item, ['title_pl']),
                fields: [
                  new fields.Input({
                    label: 'Nagłówek',
                    required: true,
                    type: 'textarea',
                    modelPath: [this, 'form', 'items', i, 'title'],
                    multilingual: true
                  }),
                  new fields.WYSIWYG({
                    label: 'Podpis',
                    modelPath: [this, 'form', 'items', i, 'subtitle'],
                    multilingual: true,
                    simple: true
                  }),
                  new fields.Input({
                    label: 'Tekst w tle',
                    modelPath: [this, 'form', 'items', i, 'bg_text'],
                    multilingual: true,
                    help:
                      'Data będzie złamana do dwóch wierszy w miejscu, w którym znajdzie się spacja.'
                  }),
                  new fields.Image({
                    label: 'Zdjęcie',
                    modelPath: [this, 'form', 'items', i, 'image'],
                    required: true
                  }),
                  new fields.Input({
                    label: 'Link do filmu YT',
                    modelPath: [this, 'form', 'items', i, 'video_url']
                  }),
                  new fields.Link({
                    label: 'Odnośnik slajdu',
                    modelPath: [this, 'form', 'items', i, 'link'],
                    hideLinkLabel: true
                  }),
                  new fields.Link({
                    label: 'Odnośnik zdjęcia',
                    modelPath: [this, 'form', 'items', i, 'image_link'],
                    hideLinkLabel: true
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  }
}
</script>
